'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'industry-windows';
var width = 576;
var height = 512;
var aliases = [127981,"industry-alt"];
var unicode = 'f3b3';
var svgPathData = 'M40 32l-8 0 0 8 0 216 0 128 0 88 0 8 8 0 496 0 8 0 0-8 0-152 0-64 0-144 0-13.6L532.1 105 368 196.9l0-84.9 0-13.9-12 7L192 200.7 192 40l0-8-8 0L40 32zm8 224L48 48l128 0 0 166.7 0 13.9 12-7 164-95.6 0 84.6 0 13.6 11.9-6.7L528 125.6 528 256l0 64 0 144L48 464l0-80 0-128zm80 48l-8 0 0 8 0 64 0 8 8 0 64 0 8 0 0-8 0-64 0-8-8 0-64 0zm8 64l0-48 48 0 0 48-48 0zm112-64l0 8 0 64 0 8 8 0 64 0 8 0 0-8 0-64 0-8-8 0-64 0-8 0zm16 16l48 0 0 48-48 0 0-48zm120-16l-8 0 0 8 0 64 0 8 8 0 64 0 8 0 0-8 0-64 0-8-8 0-64 0zm8 64l0-48 48 0 0 48-48 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIndustryWindows = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;